import type { RouteObject } from "react-router-dom";

export const aiSettingsRequestRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "AI settings request dashboard" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { AiSettingsRequestDashboardPage } =
            await import("./ai-settings-request-dashboard");
          return { Component: AiSettingsRequestDashboardPage };
        },
      },
    ],
  },
];
